// extracted by mini-css-extract-plugin
export default {"main":"NotifySidePanel_main__Zf9hZ","container":"NotifySidePanel_container__H0vAZ","footer":"NotifySidePanel_footer__X3H1e"};